import { env } from './env';

const devPrefix = env.DEV ? 'fashion:' : '';

function withPrefix(key: string) {
  return `${devPrefix}${key}`;
}

export const storageKeys = {
  accessToken: withPrefix('accessToken'),
};
